export default __webpack_public_path__ + "e5c7d0b62bae1d60abab4b2bf8f07107.png";